module.exports = __webpack_public_path__ + "img/hr-pipe-to-ground-right.b68d9490.png";